import React, { useContext } from 'react'
import styles from './Layout2.module.css'
import { ChooseContext } from '../../../../../utils/context'
import classNames from 'classnames'

export const Layout2 = () => {
  
  const {view, changeView} = useContext(ChooseContext)

  const wrapClassNames = classNames(styles.wrapper, {[styles.selected]: view === 2})

  return (
    <div className={wrapClassNames} onClick={() => changeView(2)}>
      <div className={styles.topRow}>
        <div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
        </div>
        <div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
        </div>
        <div className={styles.mainUser}></div>
        <div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
        </div>
        <div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
          <div className={styles.user}></div>
        </div>
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
        <div className={styles.user}></div>
      </div>
    </div>
  )
}
